<script setup lang="ts">
import Extension from "@/core/interfaces/extension/Extension";
import {SupportProgramMarketStatistic} from "@/program/interfaces/Program";
import ProgramKeyIndicators from "@/program/components/program-statistics/ProgramKeyIndicators.vue";
import ExtensionService from "@/extension/services/ExtensionService";

defineEmits(["activate"]);
defineProps<{
    extension: Extension;
    marketStats?: SupportProgramMarketStatistic[];
}>();
</script>

<template>
  <div class="flex flex-col p-8 gap-8">
    <div v-if="marketStats?.length" class="bg-white p-4 rounded-md">
      <h2 class="mb-2">
        Potentiel de votre officine
      </h2>
      <ProgramKeyIndicators
        v-if="ExtensionService.isSupportProgramExtension(extension)"
        :stats="marketStats"
        :support-program-id="extension.sub_id"
        grid-class="md:grid-cols-2 lg:grid-cols-3"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
